import React from "react";
import { Button } from "@mui/material";

function ActionButton(props) {
  const { children, onClick } = props;

  return <Button onClick={onClick}>{children}</Button>;
}

export default ActionButton;
